import { createSlice } from '@reduxjs/toolkit';
import { logErrorToConsole, userLocalPreferencesKey } from '../../constants';

const getInitialState = () => {
  const initialState = {
    doHideAgentCommission: false,
  };

  if (typeof window !== 'undefined') {
    const savedPreferences = localStorage.getItem(userLocalPreferencesKey);
    if (savedPreferences) {
      try {
        return JSON.parse(savedPreferences);
      } catch (e) {
        logErrorToConsole('Error parsing saved user local preferences from localStorage', e);
      }
    }
  }
  return initialState;
};

const initialState = getInitialState();

const userLocalPreferencesSlice = createSlice({
  name: userLocalPreferencesKey,
  initialState,
  reducers: {
    setUserLocalPreferences: (state, action) => {
      const { key, value } = action.payload;
      const newState = {
        ...state,
        [key]: value,
      };
      const jsonString = JSON.stringify(newState);
      localStorage.setItem(userLocalPreferencesKey, jsonString);
      return newState;
    },
  },
});

export const {
  setUserLocalPreferences,
} = userLocalPreferencesSlice.actions;

export default userLocalPreferencesSlice.reducer;
